
























































































































































































































































































































































































































































































































































































































































import Vue from "vue"
import axios from "axios"

interface DataType {
  form: {
    name: string
    mailAddress: string
    companyName: string
    phoneNumber: string
    content: string
  }
  formValidator: {
    nameIsValid: boolean
    mailAddressIsValid: boolean
    companyNameIsValid: boolean
    phoneNumberIsValid: boolean
    contentIsValid: boolean
  }
  showNavbar: boolean
  isPosting: boolean
}

const regexForEmail = /^([a-zA-Z0-9])+([a-zA-Z0-9\\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\\._-]+)+$/
const regexForPhoneNumber = /^0[0-9]{9,10}$/
const regexForPhoneNumberWithHyphen = /^0[0-9]{2,3}-[0-9]{1,4}-[0-9]{4}$/

export default Vue.extend({
  layout: "lp",
  data(): DataType {
    return {
      form: {
        name: "",
        mailAddress: "",
        companyName: "",
        phoneNumber: "",
        content: "",
      },
      formValidator: {
        nameIsValid: true,
        mailAddressIsValid: true,
        companyNameIsValid: true,
        phoneNumberIsValid: true,
        contentIsValid: true,
      },
      showNavbar: false,
      isPosting: false,
    }
  },
  head(): object {
    return this.$clHelpers.metaTag.generate({
      title: "トップ層の業務委託・副業人材マッチング｜クラウドリンクス",
      description:
        "従来までは難しかった地方の採用が変わります。クラウドリンクスでは、リモートワークや副業により都会ではたらく超一流企業の人材を活用できるようになりました。北海道から沖縄まで、全国の地方企業さまが利用しています。",
      currentPath: this.$nuxt.$route.path,
    })
  },
  computed: {
    scoutableUsers() {
      return [
        {
          name: "菊川 航希",
          role: "経営・マネジメントすべて",
          company: "OYO TECHNOLOGY&HOSPITALITY JAPAN株式会社",
          selfIntroduction:
            "OYO LIFE 事業開発責任者 過去、A.T. カーニーでのコンサルティング、シリコンバレーにてスタートアップの事業支援/投資に携わる。開成高校卒、東京大学工学部卒。",
          source: require("~/assets/images/lp/client_type3/list-to-scout/user-1@2x.png"),
        },
        {
          name: "青栁 伸子",
          role: "組織・人事コンサルタント",
          company: "合同会社NOBuコンサルティング",
          selfIntroduction:
            "エルメス、モンクレールなど国際的アパレルブランド日本法人の人事部門を歴任し独立。人材育成から組織開発、人事制度設計まで人と組織を育てることに強みを持つ。",
          source: require("~/assets/images/lp/client_type3/list-to-scout/user-2@2x.png"),
        },
        {
          name: "鈴木 誠一郎",
          role: "経営・マネジメントすべて",
          company: "フリーランス",
          selfIntroduction:
            "日産自動車出身 自動車業界の経営コンサルタントとしてBMWジャパン傘下の全国BMW正規ディーラーに対して業績改善コンサルティングに従事し担当した全店舗で売上改善を実現。",
          source: require("~/assets/images/lp/client_type3/list-to-scout/user-4@2x.png"),
        },
      ]
    },
    testimonialList() {
      return [
        {
          head: {
            logoSourceFor1x: require("~/assets/images/lp/client_type3/testimonial/img-testimonial-logo-1.png"),
            logoSourceFor2x: require("~/assets/images/lp/client_type3/testimonial/img-testimonial-logo-1@2x.png"),
            logoAlt: "eurekaロゴ",
            text: "株式会社メルカリ\nデータアナリスト",
          },
          title:
            "データ基盤 / データ活用Director\n定量・定性の両面を捉えながらユーザー体験の可視化を一緒に進めてほしい",
          firstColumn: {
            message:
              "他社様の業務支援を通して自身の知見を広げたいと考えて副業先を探していました。\nエウレカさんとお話させていただき、これまでの知識や経験を生かしてお役に立てると感じました。\nまだスタートしたばかりですがやりがいのある面白い仕事です。\nクランドリンクスを通じて想像以上に良い出会いを持てたと感じていです。",
            iconSourceFor1x: require("~/assets/images/lp/client_type3/testimonial/first-avater-1.png"),
            iconSourceFor2x: require("~/assets/images/lp/client_type3/testimonial/first-avater-1@2x.png"),
            name: "新保 直樹さん",
            role: "株式会社メルカリ｜データアナリスト",
          },
          secondColumn: {
            message:
              "Pairsは現在、お客様の利用体験向上に全力を挙げて取り組んでいます。\n新保さんはすでに我々のようなフェーズのプロダクトを経験し、弊社に必要なノウハウをお持ちで、二言ほど話しただけで今Pairsに必要な人だと確信いたしました。\n新保さんのお力でお客様と対話しながらより良いものを作れる体制にスピード感を持って近づけていると感じています。",
            iconSourceFor1x: require("~/assets/images/lp/client_type3/testimonial/second-avater-1.png"),
            iconSourceFor2x: require("~/assets/images/lp/client_type3/testimonial/second-avater-1@2x.png"),
            name: "金田 悠希さん",
            role: "株式会社エウレカ｜執行役員 VP of Pairs Japan",
          },
        },
        {
          head: {
            logoSourceFor1x: require("~/assets/images/lp/client_type3/testimonial/img-testimonial-logo-2.png"),
            logoSourceFor2x: require("~/assets/images/lp/client_type3/testimonial/img-testimonial-logo-2@2x.png"),
            logoAlt: "BULKHOMMEロゴ",
            text: "フリーランスマーケター\n元ユニ・チャーム",
          },
          title:
            "海外マーケティング戦略立案\n自社コスメの海外展開に際して、マーケティング戦略立案を手伝ってほしい",
          firstColumn: {
            message:
              "バルクオムさんは、代表の野口さんをはじめ社員のみなさんが「熱量」と「スピード」を持っている会社であると感じました。\n現在は、そのメンバーの一員として、全社のブランド戦略立案、推進を任されており、非常にタフな仕事ですが熱く充実した毎日を過ごしています。",
            iconSourceFor1x: require("~/assets/images/lp/client_type3/testimonial/first-avater-2.png"),
            iconSourceFor2x: require("~/assets/images/lp/client_type3/testimonial/first-avater-2@2x.png"),
            name: "矢野 正剛さん",
            role: "フリーランス｜マーケター",
          },
          secondColumn: {
            message:
              "弊社は、海外展開に本腰を入れるため、ブランディングやマーケティングの戦略にさらなる強度を求めるタイミングでした。\nそんな中、クラウドリンクスを通じて海外でのブランドビジネス経験が豊富な矢野さんとクラウドリンクスで出会うことができました。\n参画いただいてからは、ミスマッチを感じることなくアグレッシブに活躍していただいております。",
            iconSourceFor1x: require("~/assets/images/lp/client_type3/testimonial/second-avater-2.png"),
            iconSourceFor2x: require("~/assets/images/lp/client_type3/testimonial/second-avater-2@2x.png"),
            name: "野口 卓也さん",
            role: "株式会社バルクオム｜代表取締役CEO",
          },
        },
      ]
    },
  },
  mounted(): void {
    window.addEventListener("scroll", this.handleScroll)
  },
  destroyed(): void {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    handleScroll(): void {
      this.showNavbar = window.scrollY > 550
    },
    submit(): void {
      this.validateName()
      this.validateMailAddress()
      this.validateCompanyName()
      this.validatePhoneNumber()
      this.validateContent()

      if (
        !(
          this.formValidator.nameIsValid &&
          this.formValidator.mailAddressIsValid &&
          this.formValidator.companyNameIsValid &&
          this.formValidator.phoneNumberIsValid &&
          this.formValidator.contentIsValid
        )
      ) {
        return
      }

      this.isPosting = true

      const baseUrl = process.env.SERVICE_BASE_URL
      axios
        .post(
          `${baseUrl}/api/client_lp/contact`,
          {
            lpType: "lpType3",
            name: this.form.name,
            email: this.form.mailAddress,
            corporationName: this.form.companyName,
            phoneNumber: this.form.phoneNumber,
            content: this.form.content,
            hasThanksMail: true,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(() => {
          this.navigateToThanksPage()
        })
        .catch(() => {
          alert(
            "エラーが発生しました。大変申し訳ございませんが再度お試しください。"
          )
          this.isPosting = false
        })
    },
    validateName(): void {
      this.formValidator.nameIsValid =
        this.form.name.length > 0 && this.form.name.length < 33
    },
    validateMailAddress(): void {
      this.formValidator.mailAddressIsValid =
        regexForEmail.test(this.form.mailAddress) &&
        !this.$clHelpers.emailAddress.isFreeAddress(this.form.mailAddress)
    },
    validateCompanyName(): void {
      this.formValidator.companyNameIsValid =
        this.form.companyName.length > 0 && this.form.companyName.length < 41
    },
    validatePhoneNumber(): void {
      this.formValidator.phoneNumberIsValid =
        regexForPhoneNumber.test(this.form.phoneNumber) ||
        regexForPhoneNumberWithHyphen.test(this.form.phoneNumber)
    },
    validateContent(): void {
      this.formValidator.contentIsValid = this.form.content.length < 2000
    },
    scrollToForm(): void {
      const targetXCoordinate =
        window.innerWidth < 1024
          ? (this.$refs.scrollTarget as HTMLElement).getBoundingClientRect()
              .top + window.pageYOffset // スクロール先を指定するための計算
          : 0
      window.scrollTo(0, targetXCoordinate)
    },
    navigateToThanksPage(): void {
      this.$nuxt.$router.push({ path: "/lp/thanks" })
    },
  },
})
